import { render, staticRenderFns } from "./badDebtEdit.vue?vue&type=template&id=01afadb6&"
import script from "./badDebtEdit.vue?vue&type=script&lang=js&"
export * from "./badDebtEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports